import { Panel, PanelSection } from 'foundations-components/transitional/components/Panel';
import { CloseButton } from 'foundations-components/transitional/components/CloseButton';
import { PanelHeader } from 'foundations-components/transitional/components/PanelHeader';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { PanelBody } from 'foundations-components/transitional/components/PanelBody';
import { Text } from 'foundations-components/components/Text';
import { PanelFooter } from 'foundations-components/transitional/components/PanelFooter';
import { Button } from 'foundations-components/transitional/components/Button';
import { getRecipientNameCHIRP } from 'documents-ui/utils/getRecipientName';
import { DetailContactCardCHIRP } from './DetailContactCardCHIRP';
import { DetailViewsCardCHIRP } from './DetailViewsCardCHIRP';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const DetailPanelCHIRP = ({
  documentId,
  selectedVisitor,
  onClose
}) => {
  const contactName = selectedVisitor.contact ? getRecipientNameCHIRP(selectedVisitor.contact) : '';
  return /*#__PURE__*/_jsxs(Panel, {
    width: 600,
    children: [/*#__PURE__*/_jsx(CloseButton, {
      onClick: onClose
    }), /*#__PURE__*/_jsx(PanelHeader, {
      children: /*#__PURE__*/_jsx(Text, {
        as: "h4",
        color: "text-core-on-fill-default",
        children: contactName || /*#__PURE__*/_jsx(FormattedMessage, {
          message: "summary.recipientsTable.row.someone"
        })
      })
    }), /*#__PURE__*/_jsx(PanelBody, {
      children: /*#__PURE__*/_jsxs(PanelSection, {
        padding: "600",
        children: [/*#__PURE__*/_jsx(DetailContactCardCHIRP, {
          contact: selectedVisitor.contact
        }), /*#__PURE__*/_jsx(DetailViewsCardCHIRP, {
          documentId: documentId,
          selectedVisitor: selectedVisitor
        })]
      })
    }), /*#__PURE__*/_jsx(PanelFooter, {
      children: /*#__PURE__*/_jsx(Button, {
        use: "primary",
        onClick: onClose,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "summary.detail.footer.close"
        })
      })
    })]
  });
};